<template>
    <div class="container">
        <div class="toolbar">
            <div class="left-items">
                <a-button class="item" icon="icon icon-home" @click="on_reset" />
                <a-button class="item" ref="refresh" icon="icon icon-reset" @click="load()" />
                <a-divider type="vertical" class="item" />
                <a-range-picker
                    :disabled="loading"
                    :ranges="range_date"
                    class="item"
                    @change="on_date_change"
                    :value="date_range"
                    format="YYYY-MM-DD"
                />
            </div>

            <div class="right-items"></div>
        </div>

        <div class="main">
            <a-table
                :columns="columns"
                :dataSource="data_source"
                rowKey="user_id"
                :loading="loading"
                :pagination="false"
                size="middle"
            >
                <template slot="author_render" slot-scope="text, record">
                    <div v-if="text">
                        {{ text.name }}
                        <br />
                        <small class="id">ID：{{ text.id }}</small>
                    </div>
                </template>
            </a-table>

            <h2 class="h2"><a-icon type="info-circle" style="margin-right:12px" />数据说明</h2>
            <a-divider />

            <div class="explain-block">
                <ul>
                    <li>手动录入：通过后台创建。</li>
                    <li>
                        他人录入：其他人在创建客户时录入到指定销售。
                    </li>
                    <li>
                        平台注册：客户在平台上使用注册功能自主注册。
                    </li>
                    <li>
                        他人转入：从其他销售账户里转出。
                    </li>
                    <li>
                        操作转出：使用分配功能操作的客户数量。
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    import moment from "moment";
    import common_pagination from "../../../mixins/common_pagination.js";

    export default {
        mixins: [common_pagination],
        data() {
            return {
                path: "/data/member_distribute",
                date_range: [moment().startOf("month"), moment().endOf("month")],
                range_date: {
                    今天: [moment(), moment()],
                    昨天: [moment(new Date()).add(-1, "days"), moment(new Date()).add(-1, "days")],
                    本周: [moment().startOf("week"), moment().endOf("week")],
                    本月: [moment().startOf("month"), moment().endOf("month")],
                },
                columns: [
                    {
                        dataIndex: "name",
                        title: "姓名",
                        width: 120,
                    },
                    {
                        dataIndex: "group",
                        title: "部门",
                        width: 120,
                    },
                    {
                        dataIndex: "create",
                        title: "手动录入",
                        customRender: (e) => e || "",
                    },
                    {
                        dataIndex: "incept_create",
                        title: "他人录入",
                        customRender: (e) => e || "",
                    },
                    {
                        dataIndex: "register",
                        title: "平台注册",
                        customRender: (e) => e || "",
                    },
                    {
                        dataIndex: "incept",
                        title: "他人转入",
                        customRender: (e) => e || "",
                    },
                    {
                        dataIndex: "out",
                        title: "操作转出",
                        customRender: (e) => e || "",
                    },
                ],
                data_source: [],
                loading: false,
            };
        },
        mounted() {
            this.load();
            this.reset_query();
        },
        watch: {
            $route() {
                this.load();
            },
        },
        methods: {
            moment,
            reset_query() {
                const query = this.$route.query;
                if (Object.prototype.hasOwnProperty.call(query, "date_range")) {
                    const arr = query["date_range"].split(",");
                    if (arr.length == 2) {
                        this.date_range = [arr[0] ? moment(arr[0]) : null, arr[1] ? moment(arr[1]) : null];
                    }
                }
            },
            load() {
                this.loading = true;

                let new_query = JSON.parse(JSON.stringify(this.$route.query));
                this.$http
                    .get(`/data/member_distribute?${this.objectToQuery(new_query)}`)
                    .then((res) => {
                        if (res.success) {
                            this.data_source = res.data;
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loading = false;
                    });
            },
            on_date_change(e) {
                this.date_range = e;
                const value = [e[0].format("YYYY-MM-DD 00:00:00"), e[1].format("YYYY-MM-DD 23:59:59")];
                this.on_field_change(value.join(","), "date_range");
            },
        },
    };
</script>
<style lang="less" scoped>
    .framework-body {
        .main {
            overflow-y: auto;
            position: absolute;
            top: 56px;
            left: 0;
            right: 0;
            bottom: 0;
        }
        .id {
            color: #00000080;
        }
        .h2 {
            margin-top: 32px;
            margin-left: 16px;
        }
    }
</style>
